module.exports = __webpack_public_path__ + "static/media/Timer.e09ec1f0.png";